import { render, staticRenderFns } from "./QuestionChoice.vue?vue&type=template&id=5332fbb3"
import script from "./QuestionChoice.vue?vue&type=script&lang=js"
export * from "./QuestionChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports